 <button [class]="buttonClass" [attr.type]="type" [disabled]="this.disabled">
	@if (isLoader === true) {
        <span class="loader"></span>
    } @else if (isLoader === false || isLoader === undefined) {
		@if(showLabel){
			<label>
				{{ label | translate:ts.GetLang}}
			</label>
		}
		@if(showIcon){
			<app-icon [name]="icon" [color]="this.disabled === false ? colorIcon : 'color-fg-tertiary'" size="lg">
			</app-icon>
		}
    }
</button>
